import React, { Component } from "react";
import moment from "moment-timezone";
import Icon from "@mdi/react";
import { mdiClose } from "@mdi/js";

import styles from "./styles.scss";
import Popover from "../../Popover";
import { renderRating } from "../../../services/ValueDataService";
import { renderDrawerText } from "../../../services/DisplayService";
import { TrackingProperties } from "../../../constants";
import AnalyticsService from "../../../services/AnalyticsService";
import GameProjections from "src/components/GameProjections";
import Spacer from "src/components/Spacer";

export interface TrendPopoverProps {
  game: any;
  target: string;
  sportKey: string;
  isNew: boolean;
  filterKey: string;
  trackingProps?: TrackingProperties;
}

export interface TrendPopoverState {
  popoverOpen: boolean;
}

/**
 * This component will display more information about the value trend within the
 * games table based on the period and bet type.
 */
export default class TrendPopover extends Component<TrendPopoverProps, TrendPopoverState> {
  constructor(props: TrendPopoverProps) {
    super(props);
    this.state = {
      popoverOpen: false,
    };
  }

  toggle = () => {
    const { trackingProps } = this.props;
    if (trackingProps && !this.state.popoverOpen) {
      AnalyticsService.track("Value Rating - More Info", {
        screen: "FeedView",
        ...trackingProps,
      });
    }

    this.setState({
      popoverOpen: !this.state.popoverOpen,
    });
  };

  showTrendsDisclaimer = (sportName: string) => {
    const today = moment.utc();
    switch (sportName) {
      case "NBA":
        return today.isBefore(moment.utc("2018-10-25"));
      case "NHL":
        return today.isBefore(moment.utc("2018-10-12"));
    }
    return false;
  };

  render() {
    const { game, target, isNew, filterKey } = this.props;

    const periodFilter =
      filterKey === "spread" || filterKey === "moneyline" || filterKey === "total" ? `FG${filterKey}` : filterKey;
    const trend = game[`max${isNew ? "New" : ""}${periodFilter}Trend`];
    return (
      <Popover
        style={{
          maxWidth: "350px",
          minWidth: "350px",
          position: "relative",
        }}
        placement="right"
        isOpen={this.state.popoverOpen}
        target={target}
        toggle={this.toggle}
        trigger="legacy"
      >
        <div className="trend-popover__close-button" onClick={this.toggle}>
          <Icon path={mdiClose} size="22px" color="#000" />
        </div>
        <div className="trend-popover__container">{renderRating(trend, false)}</div>
        {isNew ? (
          renderDrawerText(game, filterKey, "trend-popover__title-text", "trend-popover__body-text")
        ) : (
          <React.Fragment>
            <div className="trend-popover__title-text">{trend && trend.displayRating ? trend.title : "No Trend"}</div>
            {trend && trend.displayRating ? (
              <div className="trend-popover__body-text">{trend.description}</div>
            ) : this.showTrendsDisclaimer(game.league.name) ? (
              <div className="trend-popover__body-text">
                BetQL's exclusive {game.league.name} trends will begin to display 5 games into the season
              </div>
            ) : null}
          </React.Fragment>
        )}
        <Spacer />
        {game.projection ? <GameProjections slug={game.slugId} /> : null}
        <style jsx global>
          {styles}
        </style>
      </Popover>
    );
  }
}
